import configData from "config/config.json";

export const extractSearchablePages = () => {
  const pages = [];
  const sideBarLinks = configData.sideBarLinks;

  Object.keys(sideBarLinks).forEach((sectionKey) => {
    const section = sideBarLinks[sectionKey];

    if (section.menu && Array.isArray(section.menu)) {
      section.menu.forEach((menuItem) => {
        pages.push({
          id: `${sectionKey}-${menuItem.title.toLowerCase().replace(/\s+/g, '-')}`,
          title: menuItem.title,
          category: section.title,
          url: menuItem.url,
          requiredRole: menuItem.requiredRole || [],
          searchTerms: `${menuItem.title} ${section.title}`.toLowerCase()
        });
      });
    }
  });

  return pages.sort((a, b) => a.title.localeCompare(b.title));
};

export const filterPagesByUserRole = (pages: any, sessionHelper: any) => {
  return pages.filter(page => {
    if (!page.requiredRole || page.requiredRole.length === 0) {
      return true;
    }
    return sessionHelper.hasRole(page.requiredRole);
  });
};

export const searchPages = (pages: any, searchTerm: any) => {
  if (!searchTerm.trim()) {
    return pages;
  }

  const term = searchTerm.toLowerCase();

  return pages
    .map(page => {
      let score = 0;
      const titleLower = page.title.toLowerCase();
      const categoryLower = page.category.toLowerCase();

      // Exact title match gets highest score
      if (titleLower === term) {
        score = 100;
      }
      // Title starts with search term
      else if (titleLower.startsWith(term)) {
        score = 90;
      }
      // Title contains search term
      else if (titleLower.includes(term)) {
        score = 80;
      }
      // Category matches
      else if (categoryLower.includes(term)) {
        score = 60;
      }
      // Fuzzy match in search terms
      else if (page.searchTerms.includes(term)) {
        score = 40;
      }
      // Partial word matches
      else {
        const words = term.split(' ');
        const matchingWords = words.filter(word =>
          titleLower.includes(word) || categoryLower.includes(word)
        );
        if (matchingWords.length > 0) {
          score = (matchingWords.length / words.length) * 30;
        }
      }

      return { ...page, score };
    })
    .filter(page => page.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 10); // Limit to top 10 results
};